// 无人机状态详情
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useRef, useEffect } from 'react'
import { Card, Space, theme, Tooltip, Tag, message, Segmented, Button } from 'antd'
import { distance } from '@/common/js/common.js'
import { InfoCircleOutlined, NotificationOutlined, FontColorsOutlined, AudioOutlined } from '@ant-design/icons'

import uav_t_p from "@/common/img/command_flight/uav/uav_t_p.svg" //已链接上  状态 p
import uav_f_p from "@/common/img/command_flight/uav/uav_f_p.svg" //未链接上  状态 p
import uav_t_a from "@/common/img/command_flight/uav/uav_t_a.svg" //已链接上  状态 a
import uav_f_a from "@/common/img/command_flight/uav/uav_f_a.svg" //未链接上  状态 a
import uav_t_m from "@/common/img/command_flight/uav/uav_t_m.svg" //已链接上  状态 m
import uav_f_m from "@/common/img/command_flight/uav/uav_f_m.svg" //未链接上  状态 m

import uav_t_dl from "@/common/img/command_flight/uav/uav_t_dl.svg" // 无人机满电池电量
import uav_f_dl from "@/common/img/command_flight/uav/uav_f_dl.svg" // 无人机缺电池电量
import uav_xdqfdgd from "@/common/img/command_flight/uav/uav_xdqfdgd.svg" // 相对起飞高度
import uav_xdjcgd from "@/common/img/command_flight/uav/uav_xdjcgd.svg" // 距离机场距离

import uav_t_ssbz from "@/common/img/command_flight/uav/uav_t_ssbz.svg" //已链接上  上视规避
import uav_f_ssbz from "@/common/img/command_flight/uav/uav_f_ssbz.svg" //未链接上  上视规避

import uav_t_xsbz from "@/common/img/command_flight/uav/uav_t_xsbz.svg" //已链接上  下视规避
import uav_f_xsbz from "@/common/img/command_flight/uav/uav_f_xsbz.svg" //未链接上  下视规避

import uav_t_spbz from "@/common/img/command_flight/uav/uav_t_spbz.svg" //已链接上  水平规避
import uav_f_spbz from "@/common/img/command_flight/uav/uav_f_spbz.svg" //未链接上  水平规避

import convergence0 from "@/common/img/command_flight/uav/convergence0.svg" //收敛 未开始
import convergence1 from "@/common/img/command_flight/uav/convergence1.svg" //收敛 收敛中
import convergence2 from "@/common/img/command_flight/uav/convergence2.svg" //收敛 收敛成功
import convergence3 from "@/common/img/command_flight/uav/convergence3.svg" //收敛 收敛失败

import rtk from "@/common/img/command_flight/uav/uav_info/rtk.svg" // rtk数量
import gps from "@/common/img/command_flight/uav/uav_info/gps.svg" // gps数量
import dj from "@/common/img/command_flight/uav/uav_info/dj.svg" // 东经
import bw from "@/common/img/command_flight/uav/uav_info/bw.svg" // 北纬
import xdqfgd from "@/common/img/command_flight/uav/uav_info/xdgd.svg" // 相对起飞高度
import hbgd from "@/common/img/command_flight/uav/uav_info/hbgd.svg" // 海拔高度 
import spsd from "@/common/img/command_flight/uav/uav_info/spsd.svg" // 水平速度
import czsd from "@/common/img/command_flight/uav/uav_info/czsd.svg" // 垂直速度
import jcjl from "@/common/img/command_flight/uav/uav_info/jcjl.svg" // 距离机场距离

function UAVTypeInfo (list) {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数

  const airportData = list.airportData
  const UAVData = list.UAVData
  const mainStatus = list.mainStatus//主状态
  const droneStatusRef = useRef(list.droneStatus)//挡位
  const [droneStatuse, setDroneStatuse] = useState(list.droneStatus)//当前组件中的状态

  const [isShowUAVInfo, setIsShowUAVInfo] = useState(false)//是否展开无人机详情
  const [megaphoneList, setMegaphoneList] = useState({//喊话器
    open: false,
    type: undefined,//喊话器类型  1:文字喊话 2:文件喊话
  })

  useEffect(() => {
    let obj = {
      droneStatus: droneStatuse ? droneStatuse : list.droneStatus,//按钮状态
      megaphoneType: megaphoneList.type,//喊话器类型
    }

    list.returnBack(obj)

    // eslint-disable-next-line
  }, [droneStatuse, megaphoneList])

  useEffect(() => {
    if (JSON.stringify(UAVData) === '{}') { return }
    if ([3, 16].indexOf(UAVData?.mode_code) < 0) {
      let meg = megaphoneList
      meg.type = 0
      meg.open = false
      setMegaphoneList({ ...meg })
    }

    if (mainStatus === 1) { //在  航线飞行时
      switch (UAVData.mode_code) {
        case 0://待机
          setDroneStatuse('P')
          break;
        case 1://起飞准备
          setDroneStatuse('A')
          break;
        case 3://手动飞行
          setDroneStatuse('P')
          break;
        case 5://航线飞行
          setDroneStatuse('A')
          break;
        case 9://自动返航
          setDroneStatuse('A')
          break;
        case 10://自动降落
          setDroneStatuse('A')
          break;
        case 17://指令飞行
          setDroneStatuse('A')
          break;

        default:
          break;
      }
    }

    // eslint-disable-next-line
  }, [UAVData])

  return (
    <Card style={{ border: 0, zIndex: 5 }} styles={{ body: { padding: '16px 24px 24px 24px' } }}>
      <>{/* 第一层 */}
        <div className='flex jcsb align_center h24'>
          <div className='flex jcl align_center  hei100'>
            <div>{/* 无人机详情、喊话器界面 */}
              <>{/* 按钮 */}
                <Tooltip title='无人机详情'>
                  <InfoCircleOutlined className='fs20 pointer marR14' onClick={() => { setIsShowUAVInfo(!isShowUAVInfo) }} />
                </Tooltip>
              </>

              <>{/* 信息 */}
                <div className='pos_abs flex_col align_end' style={{ top: 0, left: isShowUAVInfo ? '-344px' : '-48px', }} >
                  <>{/* 无人机详情 */}
                    {
                      isShowUAVInfo &&
                      <div className='w328 h132 radius8 pd8 ' style={{ backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1 }}>
                        <>{/* 无人机编号 */}
                          <div>{UAVData?.sn || `无人机信息`}</div>
                        </>

                        <>{/* 无人机 详情 */}
                          <div className='flex_row flex_shrink0'>
                            <div className='flex_auto marR16 flex_shrink0'>
                              {/* rtk数量 */}
                              <div>
                                <span className="marR8">
                                  <Tooltip title='rtk数量'>
                                    <img draggable='false' src={rtk} alt='rtk数量' />
                                  </Tooltip>
                                </span>
                                <span>
                                  {UAVData?.position_state_rtk_number || 0}
                                </span>
                              </div>
                              {/* 东经 */}
                              <div>
                                <span className="marR8">
                                  <Tooltip title='东经'>
                                    <img draggable='false' src={dj} alt='东经' />
                                  </Tooltip>
                                </span>
                                <span>{Number(UAVData?.latitude || 0).toFixed(6)}</span>
                              </div>
                              {/* 相对起飞点高度 */}
                              <div>
                                <span className="marR8">
                                  <Tooltip title='相对起飞点高度'>
                                    <img draggable='false' src={xdqfgd} alt='相对起飞点高度' />
                                  </Tooltip>
                                </span>
                                <span>{Number(UAVData?.elevation || 0).toFixed(2)} m</span>
                              </div>
                              {/* 水平速度 */}
                              <div>
                                <span className="marR8">
                                  <Tooltip title='水平速度'>
                                    <img draggable='false' src={spsd} alt='水平速度' />
                                  </Tooltip>
                                </span>
                                <span>{Number(UAVData?.horizontal_speed || 0).toFixed(1)}</span>
                              </div>
                            </div>

                            <div className='flex_auto marR16 flex_shrink0'>
                              {/* GPS数量 */}
                              <div>
                                <span className="marR8">
                                  <Tooltip title='GPS数量'>
                                    <img draggable='false' src={gps} alt='GPS数量' />
                                  </Tooltip>
                                </span>
                                <span>
                                  {UAVData?.position_state_gps_number || 0}
                                </span>
                              </div>
                              {/* 北纬 */}
                              <div>
                                <span className="marR8">
                                  <Tooltip title='北纬'>
                                    <img draggable='false' src={bw} alt='北纬' />
                                  </Tooltip>
                                </span>
                                <span>{Number(UAVData?.longitude || 0).toFixed(6)}</span>
                              </div>
                              {/* 海拔 */}
                              <div>
                                <span className="marR8">
                                  <Tooltip title='海拔'>
                                    <img draggable='false' src={hbgd} alt='海拔' />
                                  </Tooltip>
                                </span>
                                <span>{Number(UAVData?.height || 0).toFixed(1)}</span>
                                {/* <span>N/A</span> */}
                              </div>
                              {/* 垂直速度 */}
                              <div>
                                <span className="marR8">
                                  <Tooltip title='垂直速度'>
                                    <img draggable='false' src={czsd} alt='垂直速度' />
                                  </Tooltip>
                                </span>
                                <span>{Number(UAVData?.vertical_speed || 0).toFixed(1)}</span>
                              </div>
                            </div>
                            {/* 无人机离机场距离 */}
                            <div className='flex_col flex_shrink0'>
                              <div className='flex_auto'></div>
                              <div>
                                <span className="marR8">
                                  <Tooltip title='无人机离机场距离'>
                                    <img draggable='false' src={jcjl} alt='无人机离机场距离' />
                                  </Tooltip>
                                </span>
                                <span>
                                  {
                                    UAVData?.longitude && airportData?.longitude
                                      ? distance([UAVData?.longitude, UAVData?.latitude], [airportData?.longitude, airportData?.latitude]).toFixed(1)
                                      : 0.0
                                  } m
                                </span>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    }
                  </>

                  <>{/* 喊话器 详情 */}
                    {
                      megaphoneList.open && [3, 16].indexOf(UAVData?.mode_code) > -1 &&
                      <div
                        className='flex_col jcr radius8 w32'
                        style={{ marginTop: isShowUAVInfo ? '8px' : '', backgroundColor: '#141414' }}
                      >
                        <Button
                          color="default"
                          variant="link"
                          icon={<FontColorsOutlined />}
                          onClick={() => {
                            let meg = megaphoneList
                            meg.type = 0
                            setMegaphoneList({ ...meg })

                            setTimeout(() => {
                              meg.type = 1
                              setMegaphoneList({ ...meg })
                            }, 500);
                          }}
                        />

                        <Button
                          color="default"
                          variant="link"
                          icon={<AudioOutlined />}
                          onClick={() => {
                            let meg = megaphoneList
                            meg.type = 0
                            setMegaphoneList({ ...meg })

                            setTimeout(() => {
                              meg.type = 2
                              setMegaphoneList({ ...meg })
                            }, 500);
                          }}
                        />


                      </div>
                    }
                  </>
                </div>
              </>
            </div>

            <>{/* 喊话器 */}
              <Tooltip title='喊话器'>
                <NotificationOutlined
                  className={`fs20 ${[3, 16].indexOf(UAVData?.mode_code) > -1 ? '' : 'opa25'}`}
                  style={{ zIndex: 10 }}
                  onClick={() => {
                    if ([3, 16].indexOf(UAVData?.mode_code) > -1) {
                      let meg = megaphoneList
                      meg.open = !meg.open
                      meg.type = 0
                      setMegaphoneList({ ...meg })
                    }
                  }}
                />
              </Tooltip>
            </>
          </div>

          <div className='flex jcl align_center hei100'>
            <>{/* 上视避障 */}
              <Tooltip title='上视避障'>
                <img
                  className='w24 h24  marR14'
                  style={{ zIndex: 10 }}
                  draggable='false'
                  alt='上视避障'
                  src={
                    UAVData?.obstacle_avoidance_upside
                      ? uav_t_ssbz
                      : uav_f_ssbz
                  }
                />
              </Tooltip>
            </>

            <>{/* 水平避障 */}
              <Tooltip title='水平避障'>
                <img
                  className='w24 h24 marR14'
                  style={{ zIndex: 10 }}
                  draggable='false'
                  alt='水平避障'
                  src={
                    UAVData?.obstacle_avoidance_horizon
                      ? uav_t_spbz
                      : uav_f_spbz
                  }
                />
              </Tooltip>
            </>

            <>{/* 下视避障 */}
              <Tooltip title='下视避障'>
                <img
                  className='w24 h24 marR14'
                  style={{ zIndex: 10 }}
                  draggable='false'
                  alt='下视避障'
                  src={
                    UAVData?.obstacle_avoidance_downside
                      ? uav_t_xsbz
                      : uav_f_xsbz
                  }
                />
              </Tooltip>
            </>

            <>{/* 收敛状态 */}
              <Tooltip
                title={
                  Number(UAVData?.position_state_is_fixed) === 0
                    ? '未开始'
                    : Number(UAVData?.position_state_is_fixed) === 1
                      ? '收敛中'
                      : Number(UAVData?.position_state_is_fixed) === 2
                        ? '收敛成功'
                        : '收敛失败'
                }
              >
                {
                  Number(UAVData?.position_state_is_fixed) === 0
                    ? (<img className='w24 h24' draggable='false' src={convergence0} alt='收敛 未开始' />)
                    : Number(UAVData?.position_state_is_fixed) === 1
                      ? (<img className='w24 h24' draggable='false' src={convergence1} alt='收敛 收敛中' />)
                      : Number(UAVData?.position_state_is_fixed) === 2
                        ? (<img className='w24 h24' draggable='false' src={convergence2} alt='收敛 收敛成功' />)
                        : (<img className='w24 h24' draggable='false' src={convergence3} alt='收敛 收敛失败' />)
                }
              </Tooltip>
            </>

          </div>
        </div>
      </>

      <>{/* 第二层 */}
        <div className='fs99 lh80 marTB8 flex align_center jcc' style={{ zIndex: 1 }}>
          <b>
            {
              UAVData?.horizontal_speed
                ? Number(UAVData?.horizontal_speed || 0).toFixed(1)
                : Number(UAVData?.vertical_speed || 0).toFixed(1)
            }
          </b>
        </div>
      </>

      <>{/* 第三层 */}
        <div className='flex_row jcsb marT8'>
          <>{/* 飞行状态 */}
            <div className='w68 flex jcsb'>
              <>{/* P */}
                <Tooltip title='停止'>
                  <img
                    className='pointer'
                    alt='P'
                    src={list.droneStatus === 'P' ? uav_t_p : uav_f_p}
                    onClick={() => {
                      if (mainStatus === 2 && Number(UAVData?.mode_code) === 3) {
                        droneStatusRef.current = undefined; setDroneStatuse(undefined)
                        setTimeout(() => { droneStatusRef.current = 'P'; setDroneStatuse('P') }, 500);
                      }
                    }}
                  />
                </Tooltip>
              </>

              <>{/* A */}
                <Tooltip title='自动'>
                  <img
                    className='pointer'
                    alt='A'
                    src={list.droneStatus === 'A' ? uav_t_a : uav_f_a}
                    onClick={() => {
                      console.log('---', mainStatus, UAVData?.mode_code);
                      if (mainStatus === 2 && Number(UAVData?.mode_code) === 3) {

                        let meg = megaphoneList
                        meg.open = false
                        meg.type = 0
                        setMegaphoneList({ ...meg })

                        droneStatusRef.current = undefined; setDroneStatuse(undefined)
                        setTimeout(() => { droneStatusRef.current = 'A'; setDroneStatuse('A') }, 500);

                      }
                    }}
                  />
                </Tooltip>
              </>

              <>{/* M */}
                <Tooltip title='手动'>
                  <img
                    className='pointer'
                    alt='M'
                    src={list.droneStatus === 'M' ? uav_t_m : uav_f_m}
                    onClick={() => {
                      if (mainStatus === 2 && Number(UAVData?.mode_code) === 3) {
                        droneStatusRef.current = undefined; setDroneStatuse(undefined)
                        setTimeout(() => { droneStatusRef.current = 'M'; setDroneStatuse('M') }, 500);
                      }

                    }}
                  />
                </Tooltip>
              </>
            </div>
          </>

          <>{/* 速度txt */}
            <div className='opa40 lh25'>M/S</div>
          </>

          <>{/* 电量 */}
            <div className='w67 flex jcr align_center'>
              <span
                className='fs20 lh25'
                style={{ color: UAVData?.battery_capacity_percent > 30 ? '#25CB55' : '#E50019', opacity: '0.75' }}
              >
                <b>{`${UAVData?.battery_capacity_percent || 0}%`}</b>
              </span>

              <img draggable='false' src={UAVData?.battery_capacity_percent > 30 ? uav_t_dl : uav_f_dl} alt='uav_dl' />
            </div>
          </>
        </div>

      </>

      <>{/* 第四层 */}
        <div className='flex jcsb h25 marT8'>
          <>{/* 相对起飞高度 */}
            <div className='flex jcc align_center'>

              <div className='fs20 lh25 flex jcc align_center'>
                <Tooltip title='无人机绝对高度'>
                  <img draggable='false' className='marR4 w32 h25' src={uav_xdqfdgd} alt='uav_xdqfdgd' />
                </Tooltip>

                <b>{`${Number(UAVData?.height || 0).toFixed(0)}`}</b>
              </div>

              <Tooltip title='相对起飞点高度'>
                <Tag className='marL8'>{`${Number(UAVData?.elevation || 0).toFixed(0)} m`}</Tag>
              </Tooltip>
            </div>
          </>

          <>{/* 相对机场距离 */}
            <div className='fs20 lh25 flex jcc align_center'>

              <Tooltip title='相对机场距离'>
                <img draggable='false' className='marR4 w19 h25' src={uav_xdjcgd} alt='uav_xdjcgd' />
              </Tooltip>

              <b>
                {
                  UAVData?.longitude && airportData?.longitude
                    ? distance([UAVData?.longitude, UAVData?.latitude], [airportData?.longitude, airportData?.latitude]).toFixed(0)
                    : 0
                } m
              </b>
            </div>
          </>
        </div>
      </>
    </Card>
  )
}
export default UAVTypeInfo;